import { createContext, useContext } from "react";

export const WaitlistContext = createContext(() => {});
export const useWaitlist = () => useContext(WaitlistContext);
